// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Y5NE","title":"AfterFrontImage_title__10-KJ"};